import { getRefreshToken } from "../components/DmsTokenHook/DmsTokenHook";

export const userInteractionToken = (noInteraction=false) => {
    let refreshTokenData = getRefreshToken();
    if (refreshTokenData === "") return;
    if (refreshTokenData && refreshTokenData !== "undefined" && !noInteraction) {
        refreshTokenData.tokenUses += 1;
    }
    else{
        refreshTokenData.tokenUses = 0;
    }
    sessionStorage.setItem(
        "refresh",
        JSON.stringify(refreshTokenData)
    );
}
